<div class="header-container">
  <p>Please select additional stores to apply changes to:</p>
  Stores Selected: {{ storesSelected }}
</div>
<div class="scroll-list">
  <mat-checkbox [(ngModel)]="selectAll" (change)="selectAllStores()" class="checkbox"> Select All Stores </mat-checkbox>
  @for (facility of facilities; track facility) {
    <mat-checkbox
      [(ngModel)]="facility.isSelected"
      [disabled]="facility.facilityId === currentFacilityId"
      [id]="'store' + facility.facilityId"
      (change)="refreshStoresSelected()">
      Store {{ facility.facilityId }} - {{ facility.facilityName }}
    </mat-checkbox>
  }
</div>
